import {
  FAIL_GET_UBER_EATS_WINNERS,
  REQUEST_GET_UBER_EATS_WINNERS,
  SUCCESS_GET_UBER_EATS_WINNERS,
} from '../../../actions/entities/uberEats';
import {createReducer} from '../../utilities';

const initialState = {
  data: null,
  error: false,
  isFetching: false,
};

function requestFetch(state) {
  return {
    ...state,
    isFetching: true,
  };
}

function successFetch(state, action) {
  return {
    ...state,
    data: action.list,
    isFetching: false,
  };
}

function failFetch(state, action) {
  const {error} = action;
  return {
    ...state,
    isFetching: false,
    error,
  };
}

export default createReducer(initialState, {
  [REQUEST_GET_UBER_EATS_WINNERS]: requestFetch,
  [SUCCESS_GET_UBER_EATS_WINNERS]: successFetch,
  [FAIL_GET_UBER_EATS_WINNERS]: failFetch,
});



// WEBPACK FOOTER //
// ./src/reducers/app/uberEats/winners.js